import { Box, Paper, Typography, Stack, Chip } from "@mui/material";
import { CalendarToday } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import ProgramProductItem from "./ProgramProductItem";

const ProgramDayCard = ({ day, dayNumber, totalDays }) => {
    const { i18n } = useTranslation();
    const lang = i18n.language;

    return (
        <Paper 
            className="day-card"
            sx={{ 
                mb: 2, 
                overflow: "hidden",
                '@media print': {
                    pageBreakInside: 'avoid',
                    breakInside: 'avoid',
                    marginBottom: '20px',
                    marginTop: '0',
                }
            }}
        >
            {/* Day Header */}
            <Box
                sx={{
                    bgcolor: "primary.main",
                    color: "primary.contrastText",
                    p: 1.25,
                }}
            >
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack direction="row" spacing={2} alignItems="center" gap={1}>
                        <Box
                            sx={{
                                bgcolor: "background.paper",
                                color: "primary.main",
                                width: 36,
                                height: 36,
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "bold",
                                fontSize: "16px",
                            }}
                        >
                            {dayNumber}
                        </Box>
                        <Box sx={{display:'flex', alignItems:'center', gap:1}}>
                            <Typography variant="h6" fontWeight="bold" sx={{ fontSize: '18px' }}>
                                {day.day_name[lang]}
                            </Typography>
                            <Stack direction="row" spacing={0.5} alignItems="center">
                                <CalendarToday sx={{ fontSize: 16 }} />
                                <Typography variant="body1" sx={{ fontSize: '14px' }}>
                                    {format(new Date(day.date), "dd MMMM yyyy")}
                                </Typography>
                            </Stack>
                        </Box>
                    </Stack>

                    <Chip
                        label={`${dayNumber}/${totalDays}`}
                        size="small"
                        sx={{ bgcolor: "rgba(255,255,255,0.2)", color: "inherit", fontSize: '12px', fontWeight: 500 }}
                    />
                </Stack>
            </Box>

            {/* Products */}
            <Box sx={{ p: 2.5 }}>
                <Stack spacing={2}>
                    {day.products?.map((product, index) => (
                        <ProgramProductItem
                            key={product.id}
                            product={product}
                            index={index + 1}
                        />
                    ))}
                </Stack>
            </Box>
        </Paper>
    );
};

export default ProgramDayCard;
